module.exports = __webpack_public_path__ + "img/1.35d56053.png";